"use client";

export default function PageComponent({}) {
  return (
    <main className="page page-privacy-policy">
      <div className="container-m">
        <div className="page-title-holder">
          <h1 className="h1-title">
            <span className="shoulder">個人情報保護方針</span>
            <span className="title en">Privacy Policy</span>
          </h1>
        </div>

        <section className="section section-1">
          <div className="block-privacy-policy">
            <div className="block-lead">
              株式会社BG（以下、「当社」といいます）は、当社のウェブサイト（以下、「当サイト」といいます）において取得する個人情報の取り扱いについて、以下のとおりプライバシーポリシーを定めます。
            </div>
            <ul className="privacy-policy-list">
              <li className="privacy-policy-list-item">
                <h3 className="item-title bold">第1条（個人情報の定義）</h3>
                <div className="item-lead">
                  「個人情報」とは、個人情報の保護に関する法律（個人情報保護法）に基づき、生存する個人に関する情報であり、氏名、住所、電話番号、メールアドレスなど、特定の個人を識別できるもの、又は個人識別符号が含まれるものをいいます。
                </div>
              </li>

              <li className="privacy-policy-list-item">
                <h3 className="item-title bold">第2条（個人情報の取得方法）</h3>
                <div className="item-lead">
                  当サイトでは、以下の方法により個人情報を取得します。
                  <ul>
                    <li>
                      ユーザーがお問い合わせフォームを通じて送信した情報（氏名、メールアドレス、電話番号、問い合わせ内容など）
                    </li>
                  </ul>
                  また、当サイトでは、アクセス解析のためにCookie（クッキー）等を使用することがありますが、個人を特定する情報は含まれません。
                </div>
              </li>

              <li className="privacy-policy-list-item">
                <h3 className="item-title bold">第3条（個人情報の利用目的）</h3>
                <div className="item-lead">
                  取得した個人情報は、以下の目的に限り利用します。
                  <ul>
                    <li>
                      当社サービスの提供・運営のため
                    </li>
                    <li>
                      ユーザーからのお問い合わせに回答するため（本人確認を行うことを含む）
                    </li>
                    <li>
                      ユーザーが利用中のサービスの新機能、更新情報、キャンペーン等及び当社が提供する他のサービスの案内のメールを送付するため
                    </li>
                    <li>
                      メンテナンス、重要なお知らせなど必要に応じたご連絡のため
                    </li>
                    <li>
                      利用規約に違反したユーザーや、不正・不当な目的でサービスを利用しようとするユーザーの特定をし、ご利用をお断りするため
                    </li>
                    <li>
                      ユーザーにご自身の登録情報の閲覧や変更、削除、ご利用状況の閲覧を行っていただくため
                    </li>
                    <li>
                      有料サービスにおいて、ユーザーに利用料金を請求するため
                    </li>
                    <li>
                      上記の利用目的に付随する目的
                    </li>
                  </ul>
                  ※上記以外の目的で利用する場合は、事前に本人の同意を得るものとします。
                </div>
              </li>

              <li className="privacy-policy-list-item">
                <h3 className="item-title bold">第4条（第三者提供について）</h3>
                <div className="item-lead">
                  当社は、次の場合を除き、取得した個人情報を第三者に提供することはありません。
                  <ul>
                    <li>
                      本人の同意がある場合
                    </li>
                    <li>
                      法令に基づく場合
                    </li>
                    <li>
                      人の生命、身体、財産の保護に必要であり、本人の同意を得ることが困難な場合
                    </li>
                    <li>
                      業務を委託する場合（例：サーバー管理会社、メール配信業者等）で、秘密保持契約を締結した業者に対して提供する場合
                    </li>
                  </ul>
                </div>
              </li>

              <li className="privacy-policy-list-item">
                <h3 className="item-title bold">第5条（個人情報の管理と安全対策）</h3>
                <div className="item-lead">
                  当社は、個人情報の漏洩、滅失、毀損の防止等、適切な安全管理措置を講じ、個人情報の保護に努めます。また、情報への不正アクセスや紛失などに対する技術的対策も講じます。<br />
                  なお、当社が講じる安全管理措置については第８条（お問い合わせ窓口）までお問い合わせください。
                </div>
              </li>

              <li className="privacy-policy-list-item">
                <h3 className="item-title bold">第6条（個人情報の開示・訂正・削除）</h3>
                <div className="item-lead">
                  ご本人から、当社が保有する自己の個人情報について、開示、訂正、利用停止、削除等の請求があった場合には、本人確認の上で速やかに対応いたします。なお、当社におけるこれらの請求に対する受付手続きや手数料の額については、第８条（お問い合わせ窓口）までお問い合わせください。
                </div>
              </li>

              <li className="privacy-policy-list-item">
                <h3 className="item-title bold">第7条（Cookieの使用について）</h3>
                <div className="item-lead">
                  当サイトでは、ユーザーの利便性向上やサイトの分析を目的として、Cookieを使用することがあります。Cookieの使用はブラウザの設定により拒否することが可能です。
                </div>
              </li>

              <li className="privacy-policy-list-item">
                <h3 className="item-title bold">第8条（プライバシーポリシーの変更）</h3>
                <div className="item-lead">
                  個人情報の取り扱いに関するご意見、ご質問、苦情のお申し出、その他個人情報の取扱に関するお問い合わせは、以下までご連絡ください。<br />
                  事業者名： 株式会社BG<br />
                  本社 : 東京都目黒区上目黒5丁目18番11号<br />
                  メールアドレス：info[at]blacktogreen.jp<br />
                  受付時間： 平日 10:00〜17:00（土日祝を除く）
                </div>
              </li>
            </ul>
          </div>
        </section>
      </div>
    </main>
  );
}